__turbopack_context__.v({
  "__horizontalScroll": "HorizontalScroll-module-scss-module__CE2xYa____horizontalScroll",
  "horizontalScrollContainer": "HorizontalScroll-module-scss-module__CE2xYa__horizontalScrollContainer",
  "horizontalScrollImg": "HorizontalScroll-module-scss-module__CE2xYa__horizontalScrollImg",
  "horizontalScrollImgGradient": "HorizontalScroll-module-scss-module__CE2xYa__horizontalScrollImgGradient",
  "horizontalScrollImgTitle": "HorizontalScroll-module-scss-module__CE2xYa__horizontalScrollImgTitle",
  "horizontalScrollItem": "HorizontalScroll-module-scss-module__CE2xYa__horizontalScrollItem",
  "horizontalScrollWrapper": "HorizontalScroll-module-scss-module__CE2xYa__horizontalScrollWrapper",
  "horizontalScrollWrapperMob": "HorizontalScroll-module-scss-module__CE2xYa__horizontalScrollWrapperMob",
});
